import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { ApiService } from '../../../api/api.service';
import { ItistudService } from '../../../api/itistud.service';
import { LocalserviceService } from '../../../api/localservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from "@angular/cdk/collections";
@Component({
  selector: 'app-ctsctudlogin',
  templateUrl: './ctsctudlogin.component.html',
  styleUrls: ['./ctsctudlogin.component.css']
})
export class CtsctudloginComponent implements OnInit {

  bdnuForm: any;
  payForm:any;
  submitted = false;
  submittedpay = false;
  public bool_spinner:boolean = false;

  reciveuserid:any;
  reciveMobilemo:any;
  reciveemail:any;
  reciveeITIcode:any;

  reciveuserstatus:any;
  reciveiticode:any;

  public bool_failure:boolean = false;
  public bool_success:boolean = false;

  public letITICode:any;
  public letStateName:any;
  public letDistrictName:any;
  public letRollNumber:any;
  public letTraineeName:any;
  public letTraineeFatherName:any;
  public letDOB:any;
  public letITIName:any;
  public letemail:any;
  public letITIaddress:any;
  public letgender:any;
  public letTrade:any;
  public letTradecode:any;
  public letExam:any;
  public letExamid:any;
  public letduration:any;
  public letmobile:any;
  public letAmount:any;

  public bool_login:boolean = true;
  public bool_form:boolean = false;
  constructor(private formBuilder: FormBuilder, private api: ApiService, private router: Router, private httpClient: HttpClient, private Local: LocalserviceService, private Itistud: ItistudService) { }

  ngOnInit(): void {

    this.bdnuForm = this.formBuilder.group({
      regno: ['', Validators.required],
      dob: ['', Validators.required],
    });

    this.payForm = this.formBuilder.group({
      ITICode: ['', Validators.required],
      StateName: ['', Validators.required],
      DistrictName: ['', Validators.required],
      RollNumber: ['', Validators.required],
      TraineeName: ['', Validators.required],
      TraineeFatherName: ['', Validators.required],
      DOB: ['', Validators.required],
      ITIName: ['', Validators.required],
      email: ['', Validators.required],
      ITIaddress: ['', Validators.required],
      gender: ['', Validators.required],
      Trade: ['', Validators.required],
      Tradecode: ['', Validators.required],
      Exam: ['', Validators.required],
      Exaimid: ['', Validators.required],
      duration: ['', Validators.required],
      mobile: ['', Validators.required],
      amount: ['', Validators.required],
    });
  }

  get f() {
    return this.bdnuForm.controls;
  }

  get g() {
    return this.payForm.controls;
  }

  onSubmit(){
    this.submitted = true;

    if (this.bdnuForm.invalid) {
      return;
    }
    this.bool_spinner = true;
   // alert(JSON.stringify(this.bdnuForm.value))

    this.Itistud.checkITIstudlogin(this.bdnuForm.value).subscribe((result: any) => {     
      // [{"count":1,"RollNumber":"R200835000217"}] // {"status":"no data"}
      
      let count = result[0]['count'];
      if(count == 1){
        this.Itistud.checkITIstudPay(this.bdnuForm.value).subscribe((result: any) => {     
          let letempty = result.status;
        //  alert(result.status)
          if(letempty == 'empty'){
            this.bool_login = false;
            this.bool_form = true;
            this.Itistud.selectITIstud(this.bdnuForm.value).subscribe((result: any) => { 
              console.log(JSON.stringify(result));
              this.letITICode = result[0]['ITICode'];
              this.letStateName = result[0]['StateName'];
              this.letDistrictName = result[0]['DistrictName'];
              this.letRollNumber = result[0]['RollNumber'];
              this.letTraineeName = result[0]['TraineeName'];
              this.letTraineeFatherName = result[0]['TraineeFatherName'];
              this.letDOB = result[0]['DOB'];
              this.letITIName = result[0]['ITIName'];
              this.letemail = result[0]['email'];
              this.letITIaddress = result[0]['ITIaddress'];
              this.letgender = result[0]['gender'];
              this.letTrade = result[0]['Trade'];
              this.letTradecode = result[0]['Tradecode'];
              this.letExam = result[0]['Exam'];
              this.letExamid = result[0]['Exaimid'];
              this.letduration = result[0]['duration'];
              this.letmobile = result[0]['mobile'];
              this.letAmount = 376;        // 376   
             })
          }
          else if(result[0]['pstatus'] == 'DONE'){
            alert('Already Paid')
          }
          else{
            alert('Already Registerd')
          }
         });
      }
      else{
        alert("Wrong Credential ");
      }
      // this.bool_spinner = false;
      // console.log(JSON.stringify(result))
      // this.reciveuserid = result['userid'];
      // this.reciveemail = result['email'];
      // this.reciveMobilemo = result['mobile'];

      //   let args= {
      //     reciveuserid: this.reciveuserid,
      //     reciveemail: this.reciveemail,
      //     reciveMobilemo: this.reciveMobilemo
      //   };

      // this.reciveuserstatus = result['status'];
      // if(this.reciveuserstatus == 'success'){
      //  this.Local.set_login_data(args);      
      //  this.router.navigateByUrl('/examfeeiti/examitiotp');

      // }
      // else{
      //   alert('Fail Value')
      //   this.bool_failure = true;

      //   setTimeout(() => {
      //     this.bool_success = false;
      //     this.bool_failure = false;
      //   }, 5000);
      // }
      // let count:any = JSON.stringify(result.count);

      // if(count == 1){
      //   console.log(JSON.stringify(result.email))
      // }
    });
  }

  fn_update_email(){
    alert('z')
    if(this.letemail == ''){
      alert('a');
      //update table name set email='' where roll='';
    }
    else{
      alert('b')
    }
  }

  del(){
    this.Itistud.delITIstudPay().subscribe((result: any) => { 
      console.log(result)
      });

  }
  onPaySubmit(){
    
    this.bool_spinner = true;
    //window.location.href = 'https://www.nimionlineadmission.in/dgt/paynow.php';
    this.Itistud.insertITIstud(this.payForm.value).subscribe((result: any) => {   
      //alert('TEs' + JSON.stringify(result));

      if(result.status == 'sucess'){
      //alert(result.refid)
        let a = {
          userid: result.refid, // local refid
          amount: 376, //376
          bname: this.letITIName,
          baddress: 'nimi',
          bcity: 'chennai',
          bdistrict: this.letDistrictName,
          bstate: this.letStateName,
          bpincode: '600032',
          bmobile: this.letmobile,
          bemail: this.letemail,
        };

        //alert(a)
      //  window.location.href = 'https://www.nimionlineadmission.in/dgt/paynow.php';

       this.api.payMasterdata(a,"https://www.nimionlineadmission.in/dgt/paynow.php");

        
        // this.bool_login = true;
        // this.bool_form = false;
      }
      else{
        
        if(result.status == 'Already Added'){
          
          let args = {
            rollnumber: this.letRollNumber
          };
          
          this.Itistud.checkITIstudrollnum(args).subscribe((result: any) => { 
            alert('Already Registered');
            let a = {
              userid: result[0]['payrefid'], // local refid
              amount: 376, //376
              bname: this.letITIName,
              baddress: 'nimi',
              bcity: 'chennai',
              bdistrict: this.letDistrictName,
              bstate: this.letStateName,
              bpincode: '600032',
              bmobile: this.letmobile,
              bemail: this.letemail,
            };
    
    
           this.api.payMasterdata(a,"https://www.nimionlineadmission.in/dgt/paynow.php");

           })
        }
        // this.bool_login = true;
        // this.bool_form = false;
      }
     })
  }

  payMaster(){
    
      // var msg = this.payForm.value
      // var msgOb = JSON.parse(msg)
      // console.log("MSG: " + msg)
      // const formData = new FormData();
      // formData.append('data', msg);
    
      // var myargs = formData;
      // // var myargsText = this.uploadForm.value;
      // console.log(msgOb.iticode);
  
   


      let a = {
        userid: this.letITICode,
        amount: 376, // 376
        bname: this.letITIName,
        baddress: 'nimi',
        bcity: 'chennai',
        bdistrict: this.letDistrictName,
        bstate: this.letStateName,
        bpincode: '600032',
        bmobile: this.letmobile,
        bemail: this.letemail,
      };

     window.location.href = 'https://www.nimionlineadmission.in/dgt/paynow.php'

     this.api.payMasterdata(a,"https://www.nimionlineadmission.in/dgt/paynow.php");

         //  this.selected_family_member_Master.clear() 
      // this.api.payMasterdata(myargs).subscribe((data: any) => {

      // });
      
  }

  omit_number(event: any) {
    var k;
    k = event.charCode;
    return ((k >= 48 && k <= 57) || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  omit_email(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 45 || k == 46 || k == 64 || k == 95 || k == 32);
  }

  omit_text(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 32);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
  omit_spl(event: any) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || k == 47 || k == 32 || k == 95);
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  omit_all(event: any) {
    var k;
    k = event.charCode;
    return ((k >= 127 && k <= 0));
    // return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

}
